import {useEffect, useState} from "react";
import {Dialog, DialogActions, DialogContent, makeStyles} from "@material-ui/core";
import {set} from "object-path-immutable";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import DefaultType from "../../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import useConfirm from "../../../../../Utils/Confirmation/useConfirm";
import ColorPicker
    from "../../../../../../ApplicationBuilder/ApplicationDesigner/Designers/ScreenDesigner/ToolBar/Panels/Styles/InputFields/ColorPicker";

const useStyles = makeStyles(() => ({
    dialogPaper: {
        // height: '100%'
    },
    contentContainer: {
        display: 'flex', flexDirection: 'column', height: '100%'
    },
    content: {
        background: 'rgba(0,0,0,0.02)',
        borderRadius: 10,
        padding: 10,
    },
    noSelectedContainer: {
        width: '100%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(0,0,0,0.02)',
        borderRadius: 10
    }
}))

const ClassificationModal = ({open, onClose, record, saveClassification}) => {
    const [classification, setClassification] = useState();
    const [isChanged, setIsChanged] = useState(false);
    const classes = useStyles();
    const {confirm} = useConfirm();

    useEffect(() => {
        if (open) {
            if (record) {
                setClassification(record)
            }
        } else {
            setClassification({})
        }
    }, [open]);

    function onChangeFields(v, p) {
        const newValues = set(classification, p, v)
        setIsChanged(true);
        setClassification(newValues)
    }

    function onCloseDialog() {
        if (isChanged) {
            confirm({
                title: 'You have unsaved data',
                submitFn: () => {
                    onClose();
                    setIsChanged(false)
                }
            })
            return;
        }
        setIsChanged(false)
        onClose();
    }

    return (
        <Dialog open={open} onClose={onCloseDialog} maxWidth={"md"}
                classes={{paper: classes.dialogPaper}}
        >
            <DialogTitle>
                Classification
            </DialogTitle>
            <DialogContent dividers={true}>
                <div className={classes.contentContainer}>
                    <div className={classes.content}>
                        <DefaultType
                            values={classification}
                            setValue={onChangeFields}
                            field={{
                                type: 'string',
                                path: `id`,
                                label: "ID",
                                autofocus: true,
                            }}
                            fieldStyles={{
                                width: 350
                            }}
                            labelStyles={{width: 130}}
                        />
                        <DefaultType
                            values={classification}
                            setValue={onChangeFields}
                            field={{
                                type: 'number',
                                path: `from`,
                                label: "From",
                                autofocus: false,
                            }}
                            fieldStyles={{
                                width: 350
                            }}
                            labelStyles={{width: 130}}
                        />
                        <DefaultType
                            values={classification}
                            setValue={onChangeFields}
                            field={{
                                type: 'number',
                                path: `to`,
                                label: "To",
                            }}
                            fieldStyles={{
                                width: 350
                            }}
                            labelStyles={{width: 130}}
                        />
                        <DefaultType
                            values={classification}
                            setValue={onChangeFields}
                            field={{
                                type: 'string',
                                path: `name`,
                                label: "Name",
                            }}
                            fieldStyles={{
                                width: 350
                            }}
                            labelStyles={{width: 130}}
                        />
                        <ColorPicker
                            values={classification}
                            setValue={onChangeFields}
                            path={'color'}
                            label={"Color"}
                            fieldStyles={{
                                width: 350
                            }}
                            labelStyles={{width: 130}}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    saveClassification(classification)
                    onClose()
                    setIsChanged(false)
                }} variant={"contained"} size={'small'} color="primary">Save</Button>
                <Button onClick={onCloseDialog}
                        variant={"contained"}
                        size={'small'}
                        color="default"
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default ClassificationModal;